import React from 'react';
import { useParams } from 'react-router-dom';
import { MapPin, Phone, MessageCircle, Clock, Facebook, Instagram, Music2 } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { RatingStars } from '../components/commerce/RatingStars';
import { PlanBadge } from '../components/commerce/PlanBadge';

export default function BusinessPage() {
  const { slug } = useParams();
  const { merchantProfiles, customMerchants } = useApp();
  const business = customMerchants.find((m) => m.slug === slug);
  if (!business) return <div className="mx-auto max-w-[1280px] px-4 py-20 text-center text-kelate-soft">Business not found.</div>;
  const cats = merchantProfiles[business.id]?.categories || [business.category];

  return (
    <div data-testid="business-page" className="mx-auto max-w-[760px] px-4 py-10">
      <div className="overflow-hidden rounded-3xl bg-kelate-surface shadow-[0_1px_4px_rgba(81,68,55,0.08)]">
        <div className="h-44 bg-[#EFEAE2]">
          {business.banner && <img src={business.banner} alt="" className="h-full w-full object-cover" />}
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h1 className="font-display text-2xl font-semibold text-kelate-darkwood sm:text-3xl" data-testid="business-name">{business.name}</h1>
              <div className="mt-1.5 flex flex-wrap items-center gap-3 text-sm text-kelate-soft">
                {cats.map((c) => (
                  <span key={c} className="rounded-full bg-secondary px-2.5 py-0.5 text-xs font-medium text-kelate-ink">{c}</span>
                ))}
                <RatingStars rating={business.rating} />
                <PlanBadge plan={business.plan} />
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-kelate-soft">{business.description}</p>

          <div className="mt-6 space-y-3 text-sm">
            <div className="flex items-start gap-2.5 text-kelate-ink"><MapPin size={16} className="mt-0.5 shrink-0 text-kelate-wood" /> {business.address}, {business.district}, Kelantan</div>
            <div className="flex items-center gap-2.5 text-kelate-ink"><Clock size={16} className="shrink-0 text-kelate-wood" /> {business.hours}</div>
            <div className="flex items-center gap-2.5 text-kelate-ink"><Phone size={16} className="shrink-0 text-kelate-wood" /> {business.phone}</div>
          </div>

          <div className="mt-6 grid gap-2 sm:grid-cols-2">
            <a data-testid="business-whatsapp" href={`https://wa.me/${business.whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-sm bg-kelate-darkwood py-2.5 text-sm font-medium text-kelate-surface hover:bg-kelate-wood">
              <MessageCircle size={15} /> WhatsApp
            </a>
            <a data-testid="business-maps" href={`https://maps.google.com/?q=${encodeURIComponent(business.address + ', ' + business.district + ', Kelantan')}`} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-sm border border-kelate-darkwood py-2.5 text-sm font-medium text-kelate-darkwood hover:bg-secondary">
              <MapPin size={15} /> Google Maps
            </a>
          </div>

          <div className="mt-6 flex items-center gap-3 border-t border-kelate-line pt-4">
            <span className="text-xs text-kelate-soft">Follow:</span>
            <a href="#" aria-label="Facebook" className="rounded-sm border border-kelate-line p-2 text-kelate-soft hover:text-kelate-darkwood"><Facebook size={15} /></a>
            <a href="#" aria-label="Instagram" className="rounded-sm border border-kelate-line p-2 text-kelate-soft hover:text-kelate-darkwood"><Instagram size={15} /></a>
            <a href="#" aria-label="TikTok" className="rounded-sm border border-kelate-line p-2 text-kelate-soft hover:text-kelate-darkwood"><Music2 size={15} /></a>
          </div>
          <p className="mt-4 text-[11px] text-kelate-soft">Directory listing on the KELATE LIST plan. Marketplace ordering is not enabled for this business.</p>
        </div>
      </div>
    </div>
  );
}
